import { Alert, Box } from '@mui/material';
import { EmbeddedDealerSpecialsTab } from 'app/pages/ContentManagementPage/components/dealerSpecials/DealerSpecialsTab';

type DealerSpecialsEntityPanelProps = {
  dealerId: string;
  allowedIds: string[];
};

export default function DealerSpecialsEntityPanel({
  dealerId,
  allowedIds,
}: DealerSpecialsEntityPanelProps) {
  if (!allowedIds.length) {
    return (
      <Alert severity="info" sx={{ borderRadius: 2 }}>
        No dealer specials IDs were provided for this attention row.
      </Alert>
    );
  }

  if (!dealerId.trim()) {
    return (
      <Alert severity="info" sx={{ borderRadius: 2 }}>
        Select a dealer to view dealer specials.
      </Alert>
    );
  }

  return (
    <Box sx={{ minHeight: 0, flex: 1, overflow: 'hidden' }}>
      <EmbeddedDealerSpecialsTab embedded allowedRowIds={allowedIds} />
    </Box>
  );
}

